export default __webpack_public_path__ + "static/media/avatarratings.c6e536b5.svg";